export const getDateISO = date => (
  (date instanceof Date) ?
    date.toISOString().substring(0, 10) :
    date
);

export const getDateTimeISO = date => (
  (date instanceof Date) ?
    date.toISOString().replace('T', ' ').substring(0, 19) :
    date
);

export const getDateTimeUTCISO = date => {
  if (date instanceof Date === false) return date;
  const tzoffset = date.getTimezoneOffset() * 60000;
  const localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1);
  return localISOTime.replace('T', ' ').substring(0, 19);
};

export const getDateByFormatedDate = formated => {
  if (typeof formated === 'string') {
    const [date, time] = formated.split(' | ');
    if (time) {
      const [day, mount, year] = date.split('/');
      const [hour, minute] = time.split(':');
      return new Date(year, mount - 1, day, hour, minute);
    }
  }
  if (formated == null) return new Date();
  return formated;
};
